import '../../../payouts/components/forms/main.less';

import React from 'react';
import ModalBox from '../../../shared/modal';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';
import Input from '../../../shared/form-elements/input';

import withIntl from '../../../shared/intl-hoc';

function Form(props) {
	return (
		<div className="payouts-transaction-form-wrap payouts-form-in-modal">
			<form
				className="ui-form payouts-form__main clearfix"
				onSubmit={props.handleSubmit(props.submitForm)}
			>
				<div className="payouts-form__main-fields">
					<div className="ui-form__element affiliates">
						<Field
							name="sourceAffiliateId"
							placeholder={props.intl('Source affiliate')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.affiliatesLookups}
							disabled={true}
						/>
					</div>
					<div className="ui-form__element affiliates">
						<Field
							name="targetAffiliateId"
							placeholder={props.intl('Target affiliate')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.affiliatesLookups}
						/>
					</div>
					<div className="ui-form__element comment">
						<Field
							name='comment'
							placeholder={props.intl('Comment')}
							component={Input}
						/>
					</div>
				</div>
				<button type="submit" className="ui-btn ui-btn-primary apply">
					{props.intl('Apply')}
				</button>
				<button
					className="ui-btn ui-btn-cancel cancel"
					onClick={(e) => {
						e.preventDefault();
						props.toggleForm();
					}}
				>
					{props.intl('Cancel')}
				</button>
			</form>
		</div>
	);
}

function Main(props) {
	return (
		<ModalBox
			title={props.intl('Transfer balance & accumulated points to another account')}
			body={Form(props)}
			isOpen={props.isFormOpened}
			onClose={props.toggleForm}
			className="form-modal"
		/>
	);
}

export default form => reduxForm({ form })(withIntl(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/create-transfer-balance-and-accumulated-points-form/main.js